import { navigate } from "../router";

export interface Tab {
  /** Path segment; "" is the section's default tab. */
  slug: string;
  label: string;
  count?: number | undefined;
}

/**
 * Tabs within a section, driven by the URL rather than local state.
 *
 * Path-based so a tab can be linked to and survives a reload -- "here are the
 * cleaner leads" is a thing you want to be able to send someone, and a refresh
 * landing you back on the first tab is the kind of small betrayal that makes a
 * tool feel cheap.
 */
export function Tabs({
  base,
  current,
  tabs,
}: {
  base: string;
  current: string;
  tabs: Tab[];
}) {
  return (
    <div className="tabs" role="tablist">
      {tabs.map((tab) => {
        const href = tab.slug ? `${base}/${tab.slug}` : base;
        const active = current === tab.slug;
        return (
          <a
            key={tab.slug}
            className="tabs__tab"
            role="tab"
            aria-selected={active}
            href={href}
            onClick={(e) => {
              if (e.metaKey || e.ctrlKey || e.shiftKey) return;
              e.preventDefault();
              navigate(href);
            }}
          >
            {tab.label}
            {tab.count !== undefined && tab.count > 0 && (
              <span className="tabs__count">{tab.count}</span>
            )}
          </a>
        );
      })}
    </div>
  );
}
